export const environment = {
  production: true,
  baseApiUrl: 'https://api.roto-versal.com/',
  baseAppUrl: 'https://app.roto-versal.com/',
  env: 'prod'
};
